import React from 'react';
import MuiDivider, { DividerProps as MuiDividerProps } from '@mui/material/Divider';

export interface DividerProps extends MuiDividerProps {}

const DSDivider = React.forwardRef<React.ComponentRef<typeof MuiDivider>, DividerProps>(
  function DSDivider(props, ref) {
    return <MuiDivider ref={ref} {...props} />;
  },
);

export default DSDivider;
